import { render, staticRenderFns } from "./WorkLayout.vue?vue&type=template&id=65b839e8&scoped=true"
import script from "./WorkLayout.vue?vue&type=script&lang=js"
export * from "./WorkLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkLayout.vue?vue&type=style&index=0&id=65b839e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b839e8",
  null
  
)

export default component.exports